import React, { useState } from 'react';
import MySmallSelect from './MySmallSelect';
import Collapsible from '../Collapsible';
import { MenuItem, TextField } from '@material-ui/core';
import cx from 'classnames';
import {Body, SmallUppercase} from 'text';
import padding from 'assets/scss/custom/padding.module.scss';
import margin from 'assets/scss/custom/margin.module.scss';
import styles from 'assets/jss/material-dashboard-pro-react/views/itemDetailsDrawerStyle.js';
import { makeStyles } from '@material-ui/core/styles';
import RegularButton from "../../../components/CustomButtons/Button";
import {reportProblem} from "../../../api";

const useStyles = makeStyles(styles);

const TakeAction = ({ sku, setRetailerDisabled }) => {
  const classes = useStyles(styles);

  const REPORT_AN_ISSUE = 'report-issue';
  const DISCONTINUE = 'discontinue';
  const [value, setValue] = useState('');
  const [issue, setIssue] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [details, setDetails] = useState('');

  const handleUpdateValue = value => {
    if (value === DISCONTINUE) {
      setRetailerDisabled(true);
    } else {
      setRetailerDisabled(false);
    }
    setValue(value);
  };

  const handleChecked = (option, value) =>{
    if(value){
      setIssue(option)
      setSent(false)
    }
  }
  const handleSetDetails = (value) => {
    setSent(false)
    setDetails(value)
  }
  const submit = () => {
    setLoading(true)
    reportProblem(sku, issue, details).then(r => {
      setLoading(false);
      setSent(true)
    })
  }
  return (
    <Collapsible listTitle="Take Action">
      <MySmallSelect
        value={value}
        label="Product Actions"
        onChange={e => handleUpdateValue(e.target.value)}
      >
        <MenuItem value={''}></MenuItem>
        <MenuItem value={DISCONTINUE}>Discontinue</MenuItem>
        <MenuItem value={REPORT_AN_ISSUE}>Report an issue</MenuItem>
      </MySmallSelect>
      {value === 'report-issue' && (
        <div style={{ padding: '1em 0' }}>
          <TakeActionOption details={details} setDetails={handleSetDetails} option="Image is incorrect" setChecked={handleChecked} checked={issue==="Image is incorrect"} />
          <TakeActionOption details={details} setDetails={handleSetDetails} option="Title or subtitle is incorrect" setChecked={handleChecked} checked={issue==="Title or subtitle is incorrect"} />
          <TakeActionOption details={details} setDetails={handleSetDetails} option="Duplicate SKU" setChecked={handleChecked} checked={issue==="Duplicate SKU"} />
          <TakeActionOption details={details} setDetails={handleSetDetails} option="Other" setChecked={handleChecked} checked={issue==="Other"} />

          <RegularButton
            className={classes.saveButton}
            color="info"
            fullWidth
            size="sm"
            disabled={sent || loading || !issue}
            onClick={submit}
          >
            <SmallUppercase light>{sent?'Thank you':'Report issue'}</SmallUppercase>
          </RegularButton>

        </div>
      )}
    </Collapsible>
  );
};

const TakeActionOption = ({ option, checked, setChecked, details, setDetails,  ...rest }) => {
  const classes = useStyles(styles);
  const id = option.toLowerCase().replaceAll(' ', '-');

  return (
    <>
      <div className={cx(classes.flex, padding.bottom_sm)} {...rest}>
        <input
          type="radio"
          name="option"
          value={option}
          id={id}
          checked={checked}
          onChange={e => setChecked(option, e.target.checked)}
        />
        <label className={classes.label} htmlFor={id}>
          <Body>{option}</Body>
        </label>
      </div>
      {checked && (
        <TextField
          id="outlined-basic"
          label="Details"
          variant="outlined"
          margin="normal"
          value={details}
          onChange={e => setDetails(e.currentTarget.value)}

          className={margin.bottom_sm}
        />
      )}
    </>
  );
};

export default TakeAction;
